module.exports = __webpack_public_path__ + "static/b9fa957a.3.gif";